(() => {
  const id = new URLSearchParams(location.search).get('prepaid');
  if (!id) {
    window.BGAFTER = { enabled: true };
    window.BGAFTER.ready = import('/app/after-video.js').then(module => module.init(window.BGAFTER));
    return;
  }
  let saved; try { saved = id && JSON.parse(sessionStorage.getItem(`bg.purchase.${id}`) || 'null'); } catch {}
  // 10/20 저장이 막힌 브라우저(사파리 「모든 쿠키 차단」 등) — 구매 화면이 결제한 구매를 주소(prepaid · bgq · bgr — purchase.js)로 넘긴다. 저장에 없으면 그 값으로 이어 간다(저장은 편의일 뿐)
  if (!saved?.purchase) {
    const query = new URLSearchParams(location.search), questionId = query.get('bgq') || '', referenceDate = query.get('bgr') || '';
    if (/^[a-f0-9]{32}$/.test(id) && /^[a-z0-9._-]{2,60}$/i.test(questionId) && /^\d{4}-\d{2}-\d{2}$/.test(referenceDate)) saved = { purchase: { purchase: 'before-input-v1', purchaseId: id, questionId, referenceDate }, target: location.pathname + location.search };
  }
  // 10/14 — 구매 기록 없이 결제 주소(prepaid)로 온 유료 질문은 구매 화면으로(예전 설명 판 sheet.js 가 하던 일 — 판을 지우며 옮김). 무료 질문 · 오늘의 타로는 그대로
  // 10/20 사장님 「보관함이 왜 따로 있는건데 … 새로 진행을 하는데 왜 전의 결과를 신경쓰냐」 — 입력까지 연결한(이미 쓴) 구매의 주소를 다시 열어도(새로고침 · 뒤로 가기) 새 방문과 같다.
  //   지난 결과로 끌고 가거나 보관함으로 보내지 않는다(지난 결과는 보관함에서만). 결제는 됐는데 아직 입력에 잇지 않은 구매만 이어 쓴다(두 번 결제되지 않게)
  if (!saved?.purchase || saved.req) {
    const path = location.pathname, query = new URLSearchParams(location.search);
    // 10/22 심리 테스트도 웹은 1,000원 — 다른 유료 질문처럼 구매 화면으로(아이폰 앱에서는 구매 화면의 결제 메뉴가 무료로 연다 — deploy/pay.js 무료테스트)
    const free = (/^\/app\/tarot(?:\.html)?$/.test(path) && query.get('topic') === 'today') || /^0?52$/.test(query.get('c') || '');
    if (!free) location.replace(`/app/purchase.html?target=${encodeURIComponent(path + location.search)}${query.get('lang') ? '&lang=' + encodeURIComponent(query.get('lang')) : ''}`);
    return;
  }
  const purchase = saved.purchase;
  let pending = null, bound = '';
  window.BGENTRY = {
    purchase,
    restart() { const key = `bg.purchase.pending.${purchase.questionId}`; try { sessionStorage.removeItem(key); } catch {} try { localStorage.removeItem(key); } catch {} location.assign(`/app/purchase.html?target=${encodeURIComponent(saved.target)}&lang=${window.BGLANG?.locale || 'ko'}`); },
    async bind(req) {
      const key = JSON.stringify(req);
      if (key === bound) return;
      if (pending) { await pending; if (key === bound) return; }
      pending = fetch('/api/pay/bind', { method: 'POST', headers: { 'Content-Type': 'application/json', ...window.BGPAY.head() }, body: JSON.stringify({ purchase, req }), keepalive: true }).then(async r => {
        const j = await r.json().catch(() => ({}));   // 10/29 리뷰 — 5xx HTML 이면 「Unexpected token」 같은 날것 오류가 손님에게 보였다
        if (!r.ok || !j.ok) throw Object.assign(Error(j.error || '구매 연결을 다시 확인해 주세요'), { status: r.status });
        bound = key;
        try { sessionStorage.setItem(`bg.purchase.${id}`, JSON.stringify({ ...saved, req })); } catch { /* 저장이 막혀도 연결은 끝났다 — 이 화면은 그대로 이어 간다 */ }   // 쓴 구매 표시 — 이 주소를 다시 열면 새 방문(위)
        // 10/29 리뷰 — 이 구매의 기록일 때만 지운다(다른 탭이 남긴 다른 구매 기록까지 지워 환불 안내를 놓쳤다 — after-video.js 와 같게)
        try { const k = `bg.purchase.pending.${purchase.questionId}`; if (JSON.parse(localStorage.getItem(k) || 'null')?.purchaseId === purchase.purchaseId) localStorage.removeItem(k); } catch {}
        window.BGTOSS?.bound?.(purchase.purchaseId);   // 토스판 — 입력에 이었으니 이 구매의 주문 기록(보관함 다시 받기 칸)을 거둔다
      }).finally(() => { pending = null; });
      return pending;
    },
  };
  document.addEventListener('DOMContentLoaded', async () => {
    await window.BGLANG?.ready;
    const button = document.getElementById('startBtn') || document.getElementById('start');
    if (button) (button.lastElementChild || button).textContent = { ko: '시작', en: 'Start', ja: 'はじめる', 'zh-TW': '開始', 'zh-HK': '開始' }[window.BGLANG?.locale || 'ko'];
  }, { once: true });
})();
